module.exports = __webpack_public_path__ + "static/artist-management-hero-mobile-97270273695791cf0fe34a72140e4f8e.png";